import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { PlanoDto } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'card-plano-account',
  templateUrl: './card-plano-account.component.html',
  styleUrls: ['./card-plano-account.component.scss']
})

export class CardPlanoAccountComponent extends AppComponentBase {

  @Input() planos: PlanoDto[] = [];
  @Input() isAnual: boolean = false;
  @Output() onSelected = new EventEmitter<PlanoDto>();

  public planoSelecionado: PlanoDto;

  constructor(
    injector: Injector,
  ) { super(injector) }

  private onSelectedPlano(plano: PlanoDto) {
    this.planoSelecionado = plano;
    this.onSelected.emit(plano);
  }

  protected getValorPlano(plano: PlanoDto): string {
    const valor = this.isAnual ? plano.valorAnual : plano.valorMensal;

    if (valor == null) return 'R$ 0,00';

    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(valor);
  }


  protected getBeneficios(plano: PlanoDto): string[] {
    const beneficios = plano.planoBeneficios;
    const total = beneficios.length;

    if (total === 0) return [];

    const descricoes = beneficios.slice(0, 2).map(b => b.descricao);
    if (total > 2) {
      descricoes.push(`+${total - 2} benefícios`);
    }

    return descricoes;
  }
}
